import axios from "../../axios-auth";
import { i18n } from "../../i18n.js";
import qs from "qs";
const state = {
  // hold the state of the Uploads, per product part
  uploads: {},
  ppEmptyState: {
    statusUploaded: false,
    previewUploaded: false,
    previewFile: "",
    previewFileSecond: "",
    previewFileLink: "",
    fileUrl: "",
    isLoading: false,
    loadingProgress: 0,
    showPreflight: false,
    uploadedFile: null,
    uploadedFileHash: null,
    uploadedFileRelativePath: null,
    pitstopReport: false,
    showRearrange: false,
    loading: {
      isLoading: true,
      fullPage: false,
      height: 100,
      width: 100
    }
  }
};

const getters = {
  getUploads: state => {
    return state.uploads;
  },
  getUploadForProductPart: state => pp => {
    return state.uploads[pp];
  },
  getUploadItemId: (state, getters) => pp => {
    if (getters.getIsMobile) {
      return getters.getSelector + "_" + "mobile_dropzone_" + pp;
    }
    return getters.getSelector + "_" + "dropzone_" + pp;
  },
  getUploadItemIdBoth: (state, getters) => pp => {
    return [
      getters.getSelector + "_" + "dropzone_" + pp,
      getters.getSelector + "_" + "mobile_dropzone_" + pp
    ];
  },
  getFileParameters: state => fileName => {
    return (
      "path=" +
      fileName.match(/.*\//) +
      "&filename=" +
      fileName.replace(/.*\//, "")
    );
  }
};

const mutations = {
  setAttributeUploadForProductPart: (state, payload) => {
    if (state.uploads[payload.pp]) {
      var uploads = { ...state.uploads };
      uploads[payload.pp] = {
        ...uploads[payload.pp],
        [payload.key]: payload.value
      };

      state.uploads = uploads;
    }
  },
  setInitialUploads: (state, payload) => {
    var uploads = {};
    for (var code in payload) {
      uploads[payload[code]] = { ...state.ppEmptyState };
    }

    state.uploads = uploads;
  },
  setAttributeMultiUploadForProductPart: (state, payload) => {
    if (state.uploads[payload.pp]) {
      var uploads = { ...state.uploads };
      uploads[payload.pp] = {
        ...uploads[payload.pp],
        ...payload.obj
      };

      state.uploads = uploads;
    }
  }
};

const actions = {
  setAttributeUploadForProductPart: ({ commit }, payload) => {
    commit("setAttributeUploadForProductPart", payload);
  },
  setAttributeMultiUploadForProductPart: ({ commit }, payload) => {
    commit("setAttributeMultiUploadForProductPart", payload);
  },
  setInitialUploads: ({ commit }, payload) => {
    commit("setInitialUploads", payload);
  },
  uploadOnPreview: ({ getters, dispatch }, payload) => {
    if (getters.getUploadForProductPart(payload)["showRearrange"]) {
      dispatch("openFancybox", {
        src: getters.getUploadForProductPart(payload)["previewFileLink"]
      });
    } else {
      var id = getters.getUploadItemId(payload);
      if (id) {
        var elem = document.getElementById(id + "Img");
        if (elem) {
          elem.click();
        }
      }
    }
  },
  uploadOnDownload: ({ getters }, payload) => {
    const fileUrl = getters.getUploadForProductPart(payload)["fileUrl"];
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    }
  },
  uploadOnViewReport: ({ getters, dispatch }, payload) => {
    var url =
      getters.getUrl(axios.checkPreflight) +
      "?query=pdf_report&file=" +
      getters.getUploadForProductPart(payload)["uploadedFileHash"];

    dispatch("openFancybox", {
      src: url
    });
  },
  uploadOnRearrange: ({ getters, dispatch }, payload) => {
    const uploadedFileRelativePath = getters.getUploadForProductPart(payload)[
      "uploadedFileRelativePath"
    ];
    if (uploadedFileRelativePath) {
      var url =
        getters.getUrl(axios.rearrangePdf) +
        "?" +
        getters.getFileParameters(uploadedFileRelativePath) +
        "&lang=" +
        i18n.locale;

      dispatch("openFancybox", {
        src: url
      });
    }
  },
  uploadOnDelete: ({ getters, dispatch }, payload) => {
    const uploadedFile = getters.getUploadForProductPart(payload)[
      "uploadedFile"
    ];
    const uploadedFileHash = getters.getUploadForProductPart(payload)[
      "uploadedFileHash"
    ];
    if (!uploadedFile) {
      return;
    }
    dispatch("setAttributeMultiUploadForProductPart", {
      pp: payload,
      obj: {
        statusUploaded: false,
        previewUploaded: false,
        previewFile: "",
        previewFileSecond: "",
        previewFileLink: ""
      }
    });
    const uploadIdsBoth = getters.getUploadItemIdBoth(payload);
    for (var itemId in uploadIdsBoth) {
      var item = document.getElementById(uploadIdsBoth[itemId]);
      if (item) {
        item.dropzone.removeAllFiles();
      }
    }

    if (getters.getIsPreflighPitstop && uploadedFileHash) {
      dispatch("pitstopDeleteFile", uploadedFile);
    }
    if (getters.getIsMyAccount && getters.getToggleReadyToConnect) {
      getters.getToggleReadyToConnect(false);
    }
    if (getters.getIsPackingEnabled) {
      // reset the uploaded images for 3D
      dispatch("setPreview3DImage", []);
    }

    dispatch("removePreflightDataPP", payload);
    dispatch("removePreflightInfoPP", payload);
    dispatch("removeUploadedFile");
    dispatch("setFilesNeedToBeConnected", true);

    var deleteParams = {
      selection: getters.getSelectionId,
      filename: uploadedFile,
      store_code: getters.getStoreCode
    };

    axios.instance
      .post(getters.getUrl(axios.deleteFile), qs.stringify(deleteParams))
      .then(response => {
        if (!response.data.success) {
          console.log(response.data.message);
        }
        dispatch("setAttributeMultiUploadForProductPart", {
          pp: payload,
          obj: { uploadedFile: null, uploadedFileHash: null }
        });
      })
      .catch(error => {
        console.log(error);
      });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
